import axios from '../../axios';

export default {
	state: {
		notifications: {},
	},
	getters: {
		getNotifications: state => {
			return state.notifications;
		}
	},
	mutations: {
		setNotification(state, payload) {
			state.notifications[payload.key] = payload.value;
			state.notifications = Object.assign({}, state.notifications);
		},
	},
	actions: {
		async updateNotification({commit, getters}, key) {
			const url = `/${getters.getRole}/${key}`;
			const value = (await axios.get(url)).data.data;
			commit("setNotification", { key, value });
		},
		async updateNotifications({state, dispatch}) {
			for(let key in state.notifications) {
				await dispatch("updateNotification", key);
				console.log(key)
			}
		}
	}
}
